export const joyrideLocale = {
  back: 'Назад',
  close: 'Закрыть',
  last: 'Перейти',
  next: 'Дальше',
  skip: 'Пропустить',
};
export const joyrideStyles = {
  options: {
    primaryColor: '#ff6600',
  },
  tooltip: {
    borderRadius: '2px',
  },
  tooltipContainer: {
    textAlign: 'left',
  },
  buttonNext: {
    backgroundColor: '#1976d2',
    borderRadius: '2px',
    fontSize: '16px',
    color: '#ffffff',
  },
  buttonBack: {
    fontSize: '16px',
    color: '#4a4a4a',
  },
  buttonSkip: {
    fontSize: '16px',
    color: '#4a4a4a',
  },
  /**Cкопипастил из ИЕ, так как были проблемы с mix-blend-mode*/
  spotlight: {
    position: 'absolute',
    opacity: '1',
    pointerEvents: 'auto',
    boxShadow: '0px 0px 0px 9999px rgba(0,0,0,0.5), 0px 0px 15px rgba(0,0,0,0.5)',
    transitionProperty: 'opacity',
    transitionDuration: '0.2s',
    transitionTimingFunction: 'ease',
    transitionDelay: '0s',
    backgroundColor: 'transparent',
  },
  overlay: {
    backgroundColor: 'transparent',
    overflow: 'unset',
  },
};
